/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".sharedPeopleIcon_82306f4f{cursor:pointer}\n"}]);
export const sharedPeopleIcon = "sharedPeopleIcon_82306f4f";